import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import {
  getDocksListWithControlStatus,
} from '../../../app/store/actions/docks';
import OneClickButton from '../../../components/form/button';
import Table from '../../../components/table/Table';
import ROUTES from '../../../config/routes';

class LoadLinkDockModal extends React.Component {
  constructor(props) {
    super(props);

    this.defaultSorted = [
      {
        id: 'code',
        desc: false,
      },
    ];

    this.tableDockListColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="btn btn-default btn-xs"
              onClick={() => this.props.verifyDockControl(rows.row._original.code)}
            >
              {I18n.t('BEE601' /* Vincular */)}
            </button>
          </div>
        ),
      }, {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE83' /* Nome */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE224' /* Status */),
        accessor: 'openDockControl',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <span>
              {!rows.row._original.openDockControl && I18n.t('BEE4795' /* Livre */)}
              {rows.row._original.openDockControl && (
              <Link
                to={`${ROUTES.OUTBOUND_DOCK_CONTROL_MONITOR}?dockCode=${rows.row._original.code}&status=1`}
                target="_blank"
                style={{ textDecoration: 'underline' }}
              >
                {I18n.t('BEE206' /* Ocupada */)}
                {' '}
              </Link>
              )}
              {' '}

            </span>
          </div>
        ),
        filterMethod: (filter, row) => {
          if (filter.value === 'all') {
            return true;
          }
          if (filter.value === 'true') {
            return row.openDockControl === true;
          }
          if (filter.value === 'false') {
            return row.openDockControl === false;
          }
          return false;
        },
        Filter: ({ filter, onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="all">{I18n.t('BEE793' /* Todos */)}</option>
            <option value="false">{I18n.t('BEE4795' /* Livre */)}</option>
            <option value="true">{I18n.t('BEE206' /* Ocupada */)}</option>
          </select>
        ),
      },

    ];

    this.defaultFiltered = [
      {
        id: 'openDockControl',
        value: 'false',
      },
    ];

    this.state = {
      docks: [],
    };
  }

  componentDidMount() {
    this.maintainsState();
  }

  maintainsState = async () => {
    await this.getDocksListWithControlStatus();
  };

  getDocksListWithControlStatus = async () => {
    const docks = await this.props.getDocksListWithControlStatus();

    this.setState({
      docks,
    });
  };

  render() {
    const { showLinkDockModal, selectedLoad } = this.props;

    const { docks } = this.state;

    const filterDocks = docks.filter((dock) => dock.code !== selectedLoad?.dockControl?.dock?.code);

    return (
      <Modal size="lg" isOpen={showLinkDockModal} toggle={() => this.props.closeLinkDockModal()}>
        <ModalHeader toggle={() => this.props.closeLinkDockModal()} />
        <ModalBody>
          <Table
            headerTitle={selectedLoad.status === 3 ? I18n.t('BEE4646' /* Alterar Doca */)
              : I18n.t('BEE4533' /* Vincular Doca */)}
            panelHeaderProps={{ noButton: true }}
            filterable
            data={selectedLoad.status === 3 ? filterDocks : docks}
            columns={this.tableDockListColumns}
            expander
            defaultPageSize={10}
            defaultSorted={this.defaultSorted}
            defaultFiltered={this.defaultFiltered}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
              return false;
            }}
          />
        </ModalBody>
        <ModalFooter>
          <div className="row">
            <div className="col text-right">
              <OneClickButton
                className="btn btn-white btn-120 p-5 m-5"
                onClick={() => this.props.closeLinkDockModal()}
              >
                {I18n.t('BEE137' /* Voltar */)}
              </OneClickButton>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getDocksListWithControlStatus: () => dispatch(getDocksListWithControlStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoadLinkDockModal));
